import { Position } from "@xyflow/react"
import { InlineValue } from "../inline-value"
import { InputHandle } from "./custom-handle"
import { getParameterHandleTone } from "./node-appearance"
import type { NodeParameter } from "./parameter-utils"

type ParameterItemProps = {
	parameter: NodeParameter
	isConnected: boolean
	hasResolvedValue: boolean
	resolvedValue: unknown
	sourceLabel: string
	showLabel?: boolean
	showHandle: boolean
	onChange: (value: unknown) => void
	variant?: "canvas" | "sidebar"
}

export const ParameterItem = ({
	parameter,
	isConnected,
	hasResolvedValue,
	resolvedValue,
	sourceLabel,
	showLabel = true,
	showHandle,
	onChange,
	variant = "canvas",
}: ParameterItemProps) => {
	const handleTone = getParameterHandleTone(parameter, isConnected)

	return (
		<div className="relative inline-flex items-center">
			{showHandle && (
				<InputHandle
					position={Position.Top}
					id={parameter.name}
					tone={handleTone}
					anchorKind="pill"
					decorated={false}
					className="!left-0 !top-0 !translate-x-0 !translate-y-0"
					style={
						variant === "canvas"
							? {
									width: "100%",
									height: "100%",
									minWidth: "100%",
									minHeight: "100%",
								}
							: undefined
					}
				/>
			)}
			<InlineValue
				paramName={parameter.name}
				value={parameter.value}
				type={parameter.type}
				isConnected={isConnected}
				hasResolvedValue={hasResolvedValue}
				resolvedValue={resolvedValue}
				sourceLabel={sourceLabel}
				showLabel={showLabel}
				onChange={onChange}
				variant={variant}
				handleTone={handleTone}
			/>
		</div>
	)
}
